<!--
 * @Author: wangwenqi wangwenqi@veredholdings.com
 * @Date: 2025-12-27 16:27:56
 * @LastEditors: wangwenqi wangwenqi@veredholdings.com
 * @LastEditTime: 2026-02-05 14:46:23
 * @FilePath: /saas-webview/src/views/face-auth/views/face-auth-result.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div></div>
</template>

<script lang="tsx">
export default {
  name: 'face-auth-result'
};
</script>

<script lang="tsx" setup>
import { Toast } from 'vant';
import {
  getAuthFaceResult,
  getResult,
  getRiskResult,
  getUserNameByPhone
} from '../data-source/api';
import native from '@/utils/native';
import qs from 'qs';
import { useRoute } from 'vue-router';
import { FaceAuthType } from '../types';
import { storage } from 'xrk-tools';

const route = useRoute();
const bizId = (qs.parse(window.location.search.slice(1))['biz_id'] ||
  '') as string;

let info: any = {
  phone: Reflect.get(route.query as any, 'phone')
};

const from = Reflect.get(route.query, 'from') as FaceAuthType;
let req = getResult;
if ([FaceAuthType.LOGIN, FaceAuthType.WITHDRAW].includes(from)) {
  info = {
    phone: Reflect.get(route.query, 'phone') as string,
    from: Reflect.get(route.query, 'from') as string
  };
  if (Reflect.get(route.query, 'extendInfo')) {
    info.extendInfo = Reflect.get(route.query, 'extendInfo');
  }
  req = getRiskResult;
}

if ([FaceAuthType.AUTH].includes(from)) {
  req = getAuthFaceResult;
}

const errCallback = async () => {
  const { data: tmName } = await getUserNameByPhone(info);
  native.method.faceAuthFile({ tmName, ...info }); // 失败回调
};

if (!bizId) {
  errCallback();
} else {
  let count = 0;

  Toast.loading({ message: '加载中', duration: 0 });
  const check = () => {
    req({ bizId: decodeURIComponent(bizId), ...info })
      .then(res => {
        count++;
        switch (res.data.authStatus) {
          // 认证通过
          case 3:
            try {
              if (from === FaceAuthType.LOGIN) {
                native.method.faceAuthLoginComplete({
                  ...res.data,
                  type: FaceAuthType.LOGIN
                });
              } else if (from === FaceAuthType.WITHDRAW) {
                native.method.faceAuthWithdrawComplete({
                  ...res.data,
                  type: FaceAuthType.WITHDRAW
                });
              } else if (from === FaceAuthType.AUTH) {
                const eurl = storage.getStorage('eurl');
                if (+res.data.skipStatus === 1) {
                  native.method.toOtherWebview(decodeURIComponent(eurl));
                } else {
                  native.method.authenticationDone('person');
                }
              } else {
                native.method.faceAuthComplete({
                  token: res.data.token
                });
              }
            } catch (error) {
              console.warn(error);
            }
            break;
          // 认证中
          case 2:
            if (count <= 5) {
              setTimeout(check, 1000);
            } else {
              errCallback();
            }
            break;
          default:
            errCallback();
        }
      })
      .catch(() => {
        errCallback();
      });
  };
  check();
}
</script>
<style></style>
